module.exports = __webpack_public_path__ + "img/mt4-icon7.07540df.png";